import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationConfigurationComponent } from './notification-configuration.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponentModule } from '../_structural/card/card.module';
import { BreadcrumbComponentModule } from '../breadcrumb/breadcrumb.module';
import { HeaderModule } from '../../../_component/header/header.module';
import { ConfigFieldViewComponent } from './config-field-view/config-field-view.component';
import { PaginationClientSideModule } from '../pagination-client-side/pagination-client-side.module';
import { EditConfigFieldComponent } from './edit-config-field/edit-config-field.component';
import { ModalHeaderComponentModule } from '../modal-header/modal-header.module';
import { InputsModule } from '../../../_component/inputs/inputs.module';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    CardComponentModule,
    BreadcrumbComponentModule,
    HeaderModule,
    ModalHeaderComponentModule,
    PaginationClientSideModule,
    InputsModule,
  ],
  declarations: [
    NotificationConfigurationComponent,
    ConfigFieldViewComponent,
    EditConfigFieldComponent,
  ],
  exports: [
    NotificationConfigurationComponent,
  ],

})
export class NotificationConfigurationModule { }
